import content from "./aiContent";
import input from "./aiInput";
import info from "../default-icons/info";
import close from "../default-icons/close";
export default {...content, ...input, info, close};
